import type {
  PresetKey,
  TimeFilter,
} from "@/components/v2/DatePicker/constants";

import { createContext } from "react";
import type { DateRange } from "react-day-picker";

import { REPORTING_TAB_TYPES, REPORTING_VIEW_TYPES } from "./types";

export type IReportingPageContext = {
  dateRange?: DateRange;
  datePreset?: PresetKey;
  timeFilter?: TimeFilter;
  selectedTenantCategoryIds: string[] | null;
  selectedBuildingIds: string[] | null;
  viewType: REPORTING_VIEW_TYPES;
  tabType: REPORTING_TAB_TYPES;
  selectorLabel: string;
};

export const ReportingPageContext = createContext({
  dateRange: undefined,
  datePreset: undefined,
  timeFilter: undefined,
  selectedTenantCategoryIds: null,
  selectedBuildingIds: null,
  viewType: REPORTING_VIEW_TYPES.BUILDING,
  tabType: REPORTING_TAB_TYPES.TOTAL,
  selectorLabel: "",
} as IReportingPageContext);

// comment for the purpose of testing hotfix release - MAIN
